import { createFileRoute } from "@tanstack/react-router";
import { ArticleLayout } from "@/components/article-layout";
import { allGeoArticles } from "@/lib/geo-data";

// No head() here: this is the shared layout for both /geo (index) and /geo/$slug.
// Emitting SEO/canonical at the layout level would add a second
// <link rel="canonical"> (to /geo) on every child page on top of the child's own.
export const Route = createFileRoute("/geo")({
  component: GeoLayout,
});

function GeoLayout() {
  return (
    <ArticleLayout
      areaLabel="GEO fundamentals"
      base="/geo"
      articleRoute="/geo/$slug"
      groups={[{ items: allGeoArticles }]}
    />
  );
}
